import { fitApi as campaignApi } from '.';

// Bu dosya API generator tarafından üretilmez — güvenle düzenlenebilir.
// NOT: campaign-api/index.ts generator bug'ı nedeniyle `fitApi` adıyla export ediliyor.
// Burada doğru isimle (`campaignApi`) yeniden adlandırıyoruz.
export const campaignApiWithTags = campaignApi.enhanceEndpoints({
  endpoints: {
    // ---- Campaigns (Kullanıcı) ----
    listAllCampaigns: { providesTags: ['Campaigns'] },
    listCampaignsByCategory: { providesTags: ['Campaigns'] },
    getCampaign: { providesTags: ['Campaigns'] },
    getAllImageUrls: { providesTags: ['Campaigns'] },

    // ---- Campaign Categories ----
    getAllCategories: { providesTags: ['CampaignCategories'] },

    // ---- Codes ----
    generateCode: { invalidatesTags: ['Campaigns'] },

    // ---- Favorite Campaigns ----
    getFavoriteCampaignsByUserId: { providesTags: ['FavoriteCampaigns'] },
    addFavoriteCampaign: {
      invalidatesTags: ['FavoriteCampaigns', 'Campaigns'],
    },
    removeFavoriteCampaign: {
      invalidatesTags: ['FavoriteCampaigns', 'Campaigns'],
    },
  },
});
